/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseFileUpload
 */
export interface CaseFileUpload {
    /**
     * 
     * @type {string}
     * @memberof CaseFileUpload
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileUpload
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileUpload
     */
    hash: string;
}

export function CaseFileUploadFromJSON(json: any): CaseFileUpload {
    return CaseFileUploadFromJSONTyped(json, false);
}

export function CaseFileUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileUpload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'key': json['key'],
        'hash': json['hash'],
    };
}

export function CaseFileUploadToJSON(value?: CaseFileUpload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'key': value.key,
        'hash': value.hash,
    };
}


